import React from "react";

import useNumberOptions from "../../../ui/hooks/useNumberOptions";

import Form from "../../../forms/components/Form/Form";

export default function ArticleMetaDataSerieNumberSelect({ name }) {
	const { watch } = Form.useFormContext();

	const serie = watch("serie");

	const numberOptions = useNumberOptions();

	return <Form.Select name={name} options={numberOptions} disabled={!serie} allowEmpty search />;
}
